import { render, staticRenderFns } from "./ChecklistReviewedArea.vue?vue&type=template&id=424fad1f&scoped=true&"
import script from "./ChecklistReviewedArea.vue?vue&type=script&lang=js&"
export * from "./ChecklistReviewedArea.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistReviewedArea.vue?vue&type=style&index=0&id=424fad1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424fad1f",
  null
  
)

export default component.exports